import React from 'react';
import '../css/loading.css';
import family from '../images/family.png'
import error from '../images/error.png'
import loading from '../images/donut.gif'

export default function Loading(props) {
  let image = ''

  if(props.fetchingError) image = error
  else image = family

  return (
    <div className="Loading">
      {props.isFetching === false ? (
        <div className="image-container">
          <img src={image} alt="simpsons family" />
        </div>
      ) : (
        <div className="gif-container">
          <img src={loading} alt="loading spinner" />
        </div>
      )}
    </div>
  )
}